import { Status, CallAPIAction } from 'api/types'
import Actions from 'redux/actions'
import { CancelFarmerVisaResponse } from 'api/evisaAPI/farmerVisa'
import { GeneralFailResponse } from 'common/types/commonTypes'

type State = {
  errorMessage: string
} & Status

const initialState = {
  errorMessage: '',
  isLoading: false,
  success: false,
  fail: false,
}

export default (
  state: State = initialState,
  action: CallAPIAction<
    Actions.CANCEL_FARMER_VISA_ASYNC,
    Actions.CANCEL_FARMER_VISA_SUCCESS,
    Actions.CANCEL_FARMER_VISA_FAIL,
    CancelFarmerVisaResponse,
    GeneralFailResponse
  >,
): State => {
  switch (action.type) {
    case Actions.CANCEL_FARMER_VISA_ASYNC:
    case Actions.CANCEL_FARMER_VISA_SUCCESS: {
      return {
        ...state,
        ...action.status,
      }
    }
    case Actions.CANCEL_FARMER_VISA_FAIL: {
      return {
        ...state,
        ...action.status,
        errorMessage: action.payload?.error?.message || '',
      }
    }
    default:
      return state
  }
}
